import { withIcon } from '@/camo/icons/with-icon'
import ReactComponent from './svg/check.svg'

const Check = withIcon(ReactComponent, { title: 'Check' })

export { Check }
